import { ProjectLocalStorage } from '../storage/ProjectLocalStorage.js';
var getSelectedProject = function getSelectedProject(state) {
    var _state_project;
    return (_state_project = state.project) !== null && _state_project !== void 0 ? _state_project : null;
};
var getSelectedProjectId = function getSelectedProjectId(state) {
    var _getSelectedProject;
    return ((_getSelectedProject = getSelectedProject(state)) === null || _getSelectedProject === void 0 ? void 0 : _getSelectedProject.id) || ProjectLocalStorage.getProjectId();
};
var isResourceTypeAssociated = function isResourceTypeAssociated(state, resourceType) {
    var _ref;
    var _selectedProject_resources;
    var selectedProject = getSelectedProject(state);
    var associatedResources = (_ref = selectedProject === null || selectedProject === void 0 ? void 0 : (_selectedProject_resources = selectedProject.resources) === null || _selectedProject_resources === void 0 ? void 0 : _selectedProject_resources[resourceType]) !== null && _ref !== void 0 ? _ref : [];
    return associatedResources.length > 0;
};
export var ProjectSelectors = {
    getSelectedProject: getSelectedProject,
    getSelectedProjectId: getSelectedProjectId,
    isResourceTypeAssociated: isResourceTypeAssociated
};

//# sourceMappingURL=ProjectSelectors.js.map